export default class CompositionProductDescription {
  constructor({ usage, productType, additionalData, size, sizeMeasurement }) {
    this.usage = usage;
    this.productType = productType;
    this.additionalData = additionalData;
    this.size = size;
    this.sizeMeasurement = sizeMeasurement;
  }
}
